import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import ContextMenu from '~activities/ContextMenu';
import useIsActivitiesRoot from '~activities/hooks/useIsActivitiesRoot';
import { useBreakpoint } from '~/hooks';
import { useTranslation } from 'react-i18next';
import { RoutesEnum } from '~/constants/enums';

const Activities = () => {
  const { mobileScreen } = useBreakpoint();
  const router = useNavigate();
  const onActivitiesRoot = useIsActivitiesRoot();
  const { t } = useTranslation('app');

  useEffect(() => {
    if (!mobileScreen && onActivitiesRoot) {
      router(RoutesEnum.FAVORITES, { replace: true });
    }
  }, [mobileScreen, onActivitiesRoot, router]);

  return (
    <div className="layout-boundary py-3x md:py-4x">
      <div className="layout-boundary__inner flex flex-col gap-3x md:gap-4x w-full min-h-[calc(100vh-120px)]">
        <p
          className={`${onActivitiesRoot ? '' : 'hidden md:block'} text-title-1 !font-[400] px-2x md:px-0`}
        >
          {t('activities')}
        </p>
        <div className="flex gap-5x flex-col md:flex-row w-full">
          <ContextMenu />
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Activities;
